var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrapper__runnerup" }, [
    _c("h4", [_vm._v("Runners up")]),
    _vm._v(" "),
    _c(
      "ul",
      {},
      _vm._l(_vm.playerList, function(player) {
        return _c(
          "li",
          { key: "runnerup-" + player.name, staticClass: "runnerup" },
          [
            _c("div", { staticClass: "image" }, [
              _c("img", {
                attrs: { src: _vm.image(player.name).Img200, alt: player.name }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "badge" }, [
              _c("img", {
                attrs: {
                  src: _vm.team(player.team).badge,
                  alt: player.team + " team badge"
                }
              })
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(player.name))])
          ]
        )
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73b711e5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73b711e5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dally-m/runner-up.vue
// module id = null
// module chunks = 